import React, { useState, useMemo } from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

interface CategoryChipsProps {
    mainContent: any[];
    setDisplayedData: (data: any[]) => void;
}

const CategoryChipsComponent: React.FC<CategoryChipsProps> = ({ mainContent, setDisplayedData }) => {
    const [activeCategory, setActiveCategory] = useState<string | null>(null);

    // Extract unique categories from mainContent
    const categories = useMemo(() => {
        const uniqueCategories = new Set(mainContent.map((item) => item.category || 'Uncategorized'));
        return Array.from(uniqueCategories);
    }, [mainContent]);

    // Handle chip click to filter displayed data
    const handleChipClick = (category: string) => {
        if (activeCategory === category) {
            setActiveCategory(null);
            setDisplayedData(mainContent);
        } else {
            setActiveCategory(category);
            setDisplayedData(mainContent.filter((item) => item.category?.trim() === category.trim()));
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                overflowX: 'auto',
                padding: '8px',
                borderRadius: '15px',
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                whiteSpace: 'nowrap'
            }}
        >
            {categories.map((category) => (
                <Chip
                    key={category}
                    label={category}
                    onClick={() => handleChipClick(category)} // Pass category explicitly
                    sx={{
                        padding: 0.5,
                        fontWeight: 'bold',
                        color: 'black',
                        backgroundColor: activeCategory === category ? 'grey.300' : 'grey.100',
                        boxShadow: activeCategory === category ? 4 : 1
                    }}
                />
            ))}
        </Box>
    );
};

export default CategoryChipsComponent;
